import React, { useState } from 'react';
import { Input, Button, CodeCountdown } from '@/components';
import { Container, BREAKPOINTS, Flex } from '@/ui';
import { COLORS } from '@/utils/static';
import { useDispatch, useSelector } from 'react-redux';
import { investorApi, kycApi } from '@/api';
import { investorActions } from '@/store/investor';
import { userActions, userReducer } from '@/store/user';
import { Form } from 'antd';
import { Text } from '@/ui/typography';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import ChangeEmailOrPhone from '@/components/registrationComponents/ChangeEmailOrPhone';
import { usePopups } from '@/hooks';

export const Step3 = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { phone, id } = useSelector((state) => state.investor);
  const { showLoader, showInfoToast, hideLoader } = usePopups();
  const [code, setCode] = useState('');
  const [triggerSendCode, setTriggerSendCode] = useState(null);

  const handleNext = async () => {
    try {
      showLoader('Processing...');

      const res = await investorApi.verifyPhone(code, id);

      if (res.status === 200) {
        await investorApi.createPersonalAccount();
        kycApi.createVerificationInstance();
        dispatch(investorActions.resetInvestor());
        dispatch(userActions.setRole('investor'));
        dispatch(userReducer.setShowUserGuide(true));
      }
    } catch (e) {
      showInfoToast(e, true);
    } finally {
      hideLoader();
    }
  };

  return (
    <>
      <StyledRow vertical align='center'>
        <Text type='secondary'>
          {t('The verification code has been sent on your phone number:')}
        </Text>
        <Flex gap={10} align='center' wrap>
          <Text $color={COLORS.blueAntd}>{phone}</Text>
          <ChangeEmailOrPhone
            label={'phone'}
            setTriggerSendCode={() =>
              setTriggerSendCode((prevValue) => (prevValue ? prevValue + 1 : 1))
            }
          />
        </Flex>
      </StyledRow>

      <Form layout='vertical' style={{ maxWidth: '600px', width: '100%' }}>
        <StyledVerificationBlock $wide $marginTop={60}>
          <Input
            label={t('Verification code')}
            required
            placeholder={t('Enter code')}
            value={code}
            onChange={(e) => setCode(e.target.value)}
            boldLabel
          />
        </StyledVerificationBlock>

        <Container $wide>
          <StyledNextRow justify={'space-between'} $wide wrap>
            <Container $maxWidth={120} $wide>
              <Button
                type='filled'
                size={window.innerWidth <= BREAKPOINTS.sm ? 'medium' : 'large'}
                text={t('Create')}
                onClick={handleNext}
                disabled={!code}
              />
            </Container>

            <CodeCountdown
              sendCode={investorApi.sendPhoneCode}
              triggerSendCode={triggerSendCode}
              isInitialCall={true}
            />
          </StyledNextRow>
        </Container>
      </Form>
    </>
  );
};

const StyledRow = styled(Flex)`
  margin-top: 24px;

  @media (max-width: ${BREAKPOINTS.smd}px) {
    margin-top: 48px;
  }
`;

const StyledVerificationBlock = styled(Container)`
  @media (max-width: ${BREAKPOINTS.smd}px) {
    margin-top: 24px;
  }
`;

const StyledNextRow = styled(Flex)`
  margin-top: 70px;

  @media (max-width: ${BREAKPOINTS.smd}px) {
    margin-top: 40px;
  }
`;
